/* eslint-disable react/prop-types */

function Button({className, children, icon, onClick, disabled}){
    return(
        <button
            onClick={disabled ? undefined : onClick}
            disabled={disabled}
            className={` ${className} py-1 px-2 flex items-center justify-center gap-2 rounded-md ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
            {icon && <span>{icon}</span>}
            <div className=" flex items-center justify-center">{children}</div>
        </button>
    )
}


export default Button;